/** @jsx jsx */
import React, { Fragment } from 'react'

import { Box, jsx } from 'theme-ui'

import Container from '../components/Container'
import SEO from '../components/SEO'

import ReviewBlock from '../components/product/ReviewBlock'
import { graphql } from 'gatsby'
import { parseStars } from '../utils/parseStars'
import TrustPilot from '../components/TrustPilot'

const getAvgReview = reviewList => {
  var totalReviews = 0
  reviewList.map(i => {
    if (i.stars) {
      totalReviews += parseInt(i.stars)
    }
  })

  return totalReviews / reviewList.length
}

const identifiyList = (list, category) => {
  let result = []
  list.map(i => {
    const { personName, review, stars, title } = i
    result.push({ personName, review, stars, title, category: category })
  })
  return result
}

const identifiyListTP = (list, category) => {
  let result = []
  list.map(i => {
    const {
      stars,
      createdAt,
      title,
      text,
      companyReply,
      content,
      firstCompanyComment,
      consumer,
      isTrustPilot,
    } = i

    result.push({
      reply:
        (firstCompanyComment && firstCompanyComment.comment) ||
        (companyReply && companyReply.text),
      createdAt,
      personName: consumer && consumer.displayName,
      review: text || content,
      stars,
      title: title || content,
      category: null,
      isTrustPilot,
    })
  })
  return result
}

const Reviews = ({ data }) => {
  let reviewList = [
    ...identifiyListTP(data.allTrustPilotBusinessUnitReview.nodes),
    ...identifiyListTP(data.allTrustPilotProductReview.nodes),
    ...identifiyList(data.allGoogleReviewsQaChainsSheet.nodes, 'Chains'),
    ...identifiyList(data.allGoogleReviewsQaBraceletsSheet.nodes, 'Bracelets'),
    ...identifiyList(data.allGoogleReviewsQaRingsSheet.nodes, 'Rings'),
  ]

  const avgReview = getAvgReview(reviewList)

  return (
    <Fragment>
      <SEO title="Reviews - JAXXON" description="JAXXON product reviews." />
      <Container sx={{ px: [12, 20, 20, 20, 20, 70], mt: 40 }}>
        <ReviewBlock
          noTabs={true}
          reviewImages={null}
          {...{
            avgReviewScore: avgReview || 'No Reviews',
            numOfReviews: reviewList.length,
            showNumOfComments: 10,
            tabTitles: ['Reviews'],
            // options: [
            //   { value: 'Chains', label: 'Chain' },
            //   { value: 'Bracelets', label: 'Bracelet' },
            //   { value: 'Rings', label: 'Ring' },
            // ],
            comments: reviewList.map(c => ({
              ...c,
              commentSubmissionDate: c.createdAt || null,
              commentTitle: c.title,
              commentText: c.review,
              clientName: c.personName,
              stars: parseStars(c.stars),
              category: c.category,
            })),
            questions: [],
            // search: true,
          }}
        />
        {/* <Box sx={{ my: 25 }}>
          <TrustPilot
            class="trustpilot-widget"
            data-locale="en-US"
            data-template-id="5419b6ffb0d04a076446a9af"
            data-businessunit-id="5ee82db4edf1fe0001effc87"
            data-style-height="20px"
            data-style-width="100%"
            data-theme="light"
          />
        </Box> */}
      </Container>
    </Fragment>
  )
}

export const query = graphql`
  query ReviewPage {
    allTrustPilotBusinessUnitReview {
      nodes {
        id
        title
        text
        stars
        createdAt
        isTrustPilot
        companyReply {
          text
        }
        consumer {
          displayName
        }
      }
    }
    contentfulReviewImageGrid {
      images {
        fluid(maxWidth: 800) {
          ...GatsbyContentfulFluid_withWebp_noBase64
        }
      }
    }
    allTrustPilotProductReview {
      nodes {
        id
        stars
        createdAt
        content
        isTrustPilot
        firstCompanyComment {
          comment
          createdAt
        }
        consumer {
          id
          displayName
        }
      }
    }
    allTrustPilotProductReview {
      nodes {
        id
        stars
        content
        consumer {
          id
          displayName
        }
      }
    }
    allGoogleReviewsQaBraceletsSheet {
      nodes {
        personName
        review
        stars
        title
      }
    }
    allGoogleReviewsQaChainsSheet {
      nodes {
        personName
        review
        stars
        title
      }
    }
    allGoogleReviewsQaRingsSheet {
      nodes {
        personName
        review
        stars
        title
      }
    }
  }
`

export default Reviews
